var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6v1.333M8 10v.007",
    stroke: "#AB8011",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 12.667h9.333a1.332 1.332 0 001.227-1.833L9.16 2.667a1.333 1.333 0 00-2.334 0l-4.733 8.167a1.334 1.334 0 001.167 1.833",
    stroke: "#C39213",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWarningTriangle;